<template>
    <slot :subscribe :error :success :loading :email />
</template>

<script setup lang="ts">
import jsonp from 'jsonp';
import queryString from 'query-string';

const props = defineProps<{
    url: string,
    userId: string,
    audienceId: string
}>();

const { url, userId, audienceId } = toRefs(props);

const email = defineModel<string|null>('email', { default: null });

const success = ref(false);
const error = ref<string|null>(null);
const loading = ref(false);

const emit = defineEmits(['error', 'success']);

const data = computed(() => {
    return queryString.stringify({
        u: userId.value,
        id: audienceId.value,
        EMAIL: email.value
    });
});

const formatErrorMessage = (message: string) => {
    return message.replace('0 - ', '');
};

type MCData = {
    result: string,
    msg: string
};

const onResponse = (err: string, d: MCData) => {
    loading.value = false;

    if (err) {
        error.value = err;
    }

    if (d && d.result === 'error') {
        error.value = formatErrorMessage(d.msg);
    }

    if (error.value) {
        emit('error', error.value);
    } else {
        emit('success', email.value);

        success.value = true;
        email.value = null;
    }
};

const subscribe = () => {
    if (email.value === null || loading.value) {
        return;
    }

    success.value = false;
    error.value = null;
    loading.value = true;

    jsonp(
        `${url.value}?${data.value}`,
        { param: 'c' },
        onResponse
    );
};
</script>
